'use client'
import React, { useState, useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { useDraggable } from 'react-use-draggable-scroll'

const SecNav = ({ items, bg, main = false, elements = [], className }) => {
  const pathname = usePathname()
  const [isActive, setIsActive] = useState([])

  const checkIsActive = (items) =>
    items.map((item) => pathname.includes(item.link))

  if (elements.length) {
    items = items
      .filter(({ attributes }) => attributes.title === elements[0])
      .pop()
    if (elements[1]) {
      items = items.attributes.children.data
        .filter(({ attributes }) => attributes.title === elements[1])
        .pop()
    }
    if (elements[2]) {
      items = items.attributes.children.data
        .filter(({ attributes }) => attributes.title.includes(elements[2]))
        .pop()
    }
    items = items.attributes.children.data.map(({ attributes }) => ({
      name: attributes.title,
      link: attributes.url
    }))
  }

  useEffect(() => {
    setIsActive(checkIsActive(items))
  }, [])

  const ref = useRef()
  const { events } = useDraggable(ref)

  return (
    <nav>
      <div
        className={`w-full h-[85px] pl-5 lg:pl-0 whitespace-nowrap ${
          bg ? `bg-${bg}` : 'bg-white'
        } ${className}`}
      >
        <div
          className={`absolute z-10 right-0 w-10 ${
            main ? 'from-sec-grey-5' : 'from-sec-grey-4'
          } bg-gradient-to-l`}
        />
        <div
          className="flex w-full h-full items-center overflow-x-auto scrollbar-hide"
          {...events}
          ref={ref}
        >
          <ul
            className={`flex w-full px-4 lg:px-8 xl:px-30 2xl:px-40 ${
              main ? 'justify-left' : 'justify-left md:justify-center'
            }`}
          >
            {items.map((item, idx) => {
              return (
                <li key={item.name}>
                  <Link
                    href={item.link}
                    className={`text-blue text-[18px] flex text-center mr-8 ${
                      main
                        ? 'lg:text-[19px] lg:mr-8 xl:mr-12 2xl:mr-16'
                        : 'lg:text-[19px] lg:mr-6 xl:mr-10 2xl:mr-12'
                    }
                      ${
                        isActive[idx]
                          ? 'underline underline-offset-2'
                          : 'opacity-100 hover:opacity-60'
                      }`}
                    onClick={() => {
                      const isActiveMod = items.map((_item) => item === _item)
                      setIsActive(isActiveMod)
                    }}
                  >
                    {item.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default SecNav
